var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFoundImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-notFound_img_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notFound_img_1",
    "data-name": "notFound_img \\u2013 1",
    clipPath: "url(#clip-notFound_img_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14546",
    "data-name": "Group 14546",
    transform: "translate(22594 18831)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4840",
    "data-name": "Rectangle 4840",
    width: 256,
    height: 256,
    transform: "translate(-22594 -18831)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14424",
    "data-name": "Group 14424",
    transform: "translate(-432 -4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_750",
    "data-name": "Ellipse 750",
    cx: 102,
    cy: 102,
    r: 102,
    transform: "translate(-22128.484 -18797.828)",
    fill: "rgba(36,164,196,0.2)",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_751",
    "data-name": "Ellipse 751",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-21942.484 -18635.828)",
    fill: "#24a4c4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_752",
    "data-name": "Ellipse 752",
    cx: 7.758,
    cy: 7.758,
    r: 7.758,
    transform: "translate(-22103.242 -18619.586)",
    fill: "#50b6d0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_753",
    "data-name": "Ellipse 753",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-22087.727 -18607.07)",
    fill: "#166276"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_758",
    "data-name": "Ellipse 758",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-21959.484 -18777.828)",
    fill: "#2094b0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_759",
    "data-name": "Ellipse 759",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-21965.484 -18783.828)",
    fill: "#3aadca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_763",
    "data-name": "Ellipse 763",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(-21930.484 -18728.377)",
    fill: "#166276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M153.549-689.742a14.438,14.438,0,0,0-.413-4.131c-.92-3.729-5.148-5.934-9.521-6.5a14.138,14.138,0,0,0-7.6.949,6.647,6.647,0,0,0-3.153,2.8,5.467,5.467,0,0,0-.715,4.234,5.582,5.582,0,0,0,2.441,2.935c3.854,2.541,10.6,3.081,13.673,2.019A37.21,37.21,0,0,0,153.549-689.742Zm1.59-.886a16.03,16.03,0,0,0-.471-3.656c-1.064-4.308-5.81-7.075-10.861-7.725s-10.3.83-12.323,4.578a7.093,7.093,0,0,0-.844,5.546,7.215,7.215,0,0,0,3.1,3.834c4.229,2.787,11.635,3.355,15.014,2.191a37.785,37.785,0,0,0,4.575-1.935c-.849,4.871-4.017,9.486-8.244,13.644-9.186,9.038-23.441,15.9-31.2,18.42a.832.832,0,0,0-.519,1.033.785.785,0,0,0,.99.544c7.916-2.572,22.448-9.578,31.816-18.795,4.84-4.76,8.288-10.12,8.877-15.754,10.94-6.1,19.924-17.181,27.605-26.5a.851.851,0,0,0-.084-1.165.77.77,0,0,0-1.116.087c-7.368,8.94-15.919,19.575-26.318,25.655",
    transform: "translate(-22256.334 -18071.26)",
    fill: "#1d839d",
    fillRule: "evenodd",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14423",
    "data-name": "Group 14423",
    transform: "translate(179.516 7.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-22251.031 -18753.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24969",
    "data-name": "Path 24969",
    d: "M84.063,16.584,68.48,1H6V99.606H84.063ZM69.683,8.013,77.05,15.38H69.683ZM10.109,95.5V5.109H65.575v14.38h14.38V95.5Z",
    fill: "#24a4c4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14422",
    "data-name": "Group 14422",
    transform: "translate(-22230.045 -18712.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14421",
    "data-name": "Group 14421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24970",
    "data-name": "Path 24970",
    d: "M33.581,28.868c2.425-1.97-1.137-5.683-3.486-3.486-2.122,1.894-4.168,4.319-6.441,6.062-2.046-1.97-7.047-8.79-8.411-6.138-.682,1.364.758,2.955,1.516,3.94,1.212,1.667,2.5,3.183,3.789,4.774,1.212,1.516,2.728,2.8,4.622,1.591C28.2,33.794,30.853,31.066,33.581,28.868Z",
    transform: "translate(-15.065 -24.703)",
    fill: "#1d839d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24971",
    "data-name": "Path 24971",
    d: "M68.1,25.383c-2.122,1.894-4.168,4.319-6.441,6.062-2.046-1.97-7.047-8.79-8.411-6.138-.682,1.364.758,2.955,1.516,3.94,1.212,1.667,2.5,3.183,3.789,4.774,1.212,1.516,2.728,2.8,4.622,1.591,2.955-1.894,5.683-4.547,8.335-6.744C74.006,26.9,70.444,23.185,68.1,25.383Z",
    transform: "translate(-24.27 -24.703)",
    fill: "#1d839d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24972",
    "data-name": "Path 24972",
    d: "M48.222,57.492C46.328,55.446,43.9,53.4,40.948,53.4c-2.8,0-5.153,1.743-7.047,3.713a39.121,39.121,0,0,0-6.365,8.638c-.834,1.667,1.061,4.319,2.879,2.879a35.118,35.118,0,0,0,5.229-5.38c1.212-1.44,2.652-4.092,4.622-4.622s3.637,1.743,4.774,2.955a58.91,58.91,0,0,1,5.3,6.214c1.894,2.576,6.289.076,4.4-2.576A76.582,76.582,0,0,0,48.222,57.492Z",
    transform: "translate(-18.036 -31.654)",
    fill: "#1d839d"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path592",
    d: "M646.689-1128.349a2.958,2.958,0,0,0,2.958-2.958,2.958,2.958,0,0,0-2.958-2.958,2.958,2.958,0,0,0-2.958,2.958A2.958,2.958,0,0,0,646.689-1128.349Zm0-1.263a1.709,1.709,0,0,0,1.694-1.694,1.709,1.709,0,0,0-1.694-1.694,1.709,1.709,0,0,0-1.694,1.694,1.689,1.689,0,0,0,1.694,1.694",
    transform: "translate(-22736.172 -17585.871)",
    fill: "#50b6d0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592-2",
    "data-name": "path592",
    d: "M647.481-1126.764a3.751,3.751,0,0,0,3.75-3.75,3.751,3.751,0,0,0-3.75-3.75,3.751,3.751,0,0,0-3.75,3.75A3.751,3.751,0,0,0,647.481-1126.764Zm0-1.6a2.167,2.167,0,0,0,2.148-2.148,2.167,2.167,0,0,0-2.148-2.148,2.167,2.167,0,0,0-2.148,2.148,2.142,2.142,0,0,0,2.148,2.148",
    transform: "translate(-22664.965 -17626.09)",
    fill: "#50b6d0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path592-3",
    "data-name": "path592",
    d: "M646.285-1129.157a2.554,2.554,0,0,0,2.554-2.554,2.554,2.554,0,0,0-2.554-2.554,2.554,2.554,0,0,0-2.554,2.554A2.554,2.554,0,0,0,646.285-1129.157Zm0-1.09a1.476,1.476,0,0,0,1.463-1.463,1.476,1.476,0,0,0-1.463-1.463,1.476,1.476,0,0,0-1.463,1.463,1.459,1.459,0,0,0,1.463,1.463",
    transform: "translate(-22625.77 -17567.869)",
    fill: "#50b6d0",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundImg);
export default __webpack_public_path__ + "static/media/notFound_img.d986da51c957553bb403553f7384257c.svg";
export { ForwardRef as ReactComponent };